import { render, staticRenderFns } from "./message.vue?vue&type=template&id=01588b12&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&lang=css&"
import style1 from "./message.vue?vue&type=style&index=1&id=01588b12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01588b12",
  null
  
)

export default component.exports